export const TERMS_SECTIONS = [
  {
    id: "agreement",
    titleKey: "term_condition_section_title1",
    paragraphKeys: ["term_condition_section_para1"],
  },
  {
    id: "user-account",
    titleKey: "term_condition_section_title2",
    paragraphKeys: ["term_condition_section_para21", "term_condition_section_para22"],
  },
  {
    id: "cab-booking",
    titleKey: "term_condition_section_title3",
    paragraphKeys: [
      "term_condition_section_para31",
      "term_condition_section_para32",
      "term_condition_section_para33",
    ],
  },
  {
    id: "payment-cancellation",
    titleKey: "term_condition_section_title4",
    paragraphKeys: ["term_condition_section_para41", "term_condition_section_para42"],
  },
  {
    id: "user-conduct",
    titleKey: "term_condition_section_title5",
    paragraphKeys: [
      "term_condition_section_para51",
      "term_condition_section_para52",
      "term_condition_section_para53",
      "term_condition_section_para54",
    ],
  },
  {
    id: "liability",
    titleKey: "term_condition_section_title6",
    paragraphKeys: ["term_condition_section_para61", "term_condition_section_para62"],
  },
  {
    id: "intellectual-property",
    titleKey: "term_condition_section_title7",
    paragraphKeys: ["term_condition_section_para71", "term_condition_section_para72"],
  },
  {
    id: "privacy",
    titleKey: "term_condition_section_title8",
    paragraphKeys: ["term_condition_section_para8"],
  },
  {
    id: "amendments",
    titleKey: "term_condition_section_title9",
    paragraphKeys: ["term_condition_section_para9"],
  },
];
